import React, { useEffect } from "react";
import "./HomePage.css";

const HomePage = () => {
  useEffect(() => {
    const yearEl = document.getElementById("year");
    if (yearEl) yearEl.textContent = new Date().getFullYear();
  }, []);

  return (
    <div className="home">
      <header className="header">
        <h1>Gate Guard</h1>
        <p className="subtitle">
          Secure and simplify your society with digital gate management.
        </p>
      </header>

      <main className="main">
        <h2>Download Our Apps</h2>
        <div className="buttons">
          <a href="/downloads/SRS_Guard.apk" download className="btn">
            Download Guard App
          </a>
          <a href="/downloads/SRS.apk" download className="btn secondary">
            Download Owner App
          </a>
        </div>

<section className="contact">
  <h3>Contact Us</h3>
  <p>
    For any support or security assistance, feel free to reach us at:
  </p>

  <p>
    Phone: <a href="tel:+918299685759">+91-8299685759</a>
  </p>
</section>
      </main>

      <footer className="footer">
        © <span id="year"></span> Gate Guard 
      </footer>
    </div>
  );
};

export default HomePage;
